import { TagEntity } from '../graphql/generated/graphql';
export const tags: TagEntity[] = [
  {
    id: '1',
    attributes: {
      label: 'Article',
      slug: 'article',
      isVisible: true,
    },
  },
  {
    id: '2',
    attributes: {
      label: 'Video',
      slug: 'video',
      isVisible: true,
    },
  },
  {
    id: '3',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
];

export const lotsOfTags: TagEntity[] = [
  ...tags,
  {
    id: '4',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '5',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '6',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '7',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '8',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '9',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '10',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '11',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
  {
    id: '12',
    attributes: {
      label: 'How To',
      slug: 'how-to',
      isVisible: true,
    },
  },
];
